import React from 'react';
import {ConsultationSummary} from '@/interface';
import {Icon, Text} from '@/ui-kits';
import { formatName } from '@/utils/common_functions';

interface PreviousCaseDetailsProps {
  previousConsultation: NonNullable<ConsultationSummary['previous_consultation']>;
}
export const PreviousCaseDetails: React.FC<PreviousCaseDetailsProps> = props => {
  const {previousConsultation} = props;
  
  return (
    <div className="border-ui_blue_light border rounded-lg px-6 py-4 flex gap-2 bg-white">
      <Icon type='file_info' className='mt-[6px]'/>
      <div className='flex flex-col gap-2'>
        <Text variant="title" className='text-ui_blue'>Referral Details</Text>
        <Text className='text-ui_blue !font-FigtreeRegular'><b className='!font-FigtreeSemiBold'>Referred by : </b>Dr. {formatName(previousConsultation.specialist_name)} ({previousConsultation.category.label})</Text>
        <Text className='text-ui_blue !font-FigtreeRegular'><b className='!font-FigtreeSemiBold'>Reason for Referral : </b>{previousConsultation.reason}</Text>
      </div>
    </div>
  );
};
